const jwt = require('jsonwebtoken')

export default {
  industries: (state) => {
    let { isAdmin } = jwt.verify(window.localStorage.getItem('is-admin'), process.env.VUE_APP_JWT_KEY)
    return state.industries.filter((industry) => !industry.is_test || (industry.is_test && isAdmin))
  },

  industryNamesAndIds: (_, getters) => {
    const filteredIndustries = getters.industries
    return filteredIndustries.map((industry) => ({ name: industry.name, _id: industry._id }))
  },
}
